/**
 * TaskSettingsService
 * Service for task management system settings.
 * Route: api/tasks/settings
 */
export class TaskSettingsService {
    constructor(http, config) {
        this.http = http;
        this.basePath = config?.basePath ?? 'api/tasks/settings';
        // Service prefix the gateway uses to route this microservice. Mirrors the
        // TaskPortalBaseService behaviour so the URL becomes /tasks/api/... and
        // the proxy actually reaches the TaskManagement WebAPI (a bare /api/...
        // returns 404 from the gateway).
        this.servicePath = config?.servicePath ?? 'tasks';
    }
    buildUrl() {
        return `/${this.servicePath}/${this.basePath}`.replace(/\/+/g, '/');
    }
    async getSettings() {
        const response = await this.http.get(this.buildUrl());
        return response.data;
    }
    async getSettingsRaw() {
        return this.http.get(this.buildUrl());
    }
    async updateSettings(settings) {
        const response = await this.http.put(this.buildUrl(), settings);
        return response.data;
    }
    async updateSettingsRaw(settings) {
        return this.http.put(this.buildUrl(), settings);
    }
}
//# sourceMappingURL=TaskSettingsService.js.map